<template>
  <Icon
    v-if="isInstantlyPublished"
    v-tooltip="$t('PUBLISHING.MP_INTPUB.HINT')"
    icon="rocket"
    class="instant-publishing-icon"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {
  CompositionPosType,
  isInstantlyPublished as _isInstantlyPublished,
} from 'commons/api/models/publishingCore/compositionPosStates';
import { Composition } from '@spreadgroup/common-partner-lib/composition';

const props = defineProps<{
  composition: Composition;
  relevantPosTypes: CompositionPosType[];
}>();

const isInstantlyPublished = computed(() => {
  return props.relevantPosTypes.some((posState) =>
    _isInstantlyPublished(props.composition, posState),
  );
});
</script>

<style scoped lang="scss">
@import 'src/scss/styleguide/colors';

.instant-publishing-icon {
  height: 20px;
  width: 20px;
  margin-left: 4px;
  color: $pa-color-green;
}
</style>
